import React from 'react';
import { NavLink } from 'react-router-dom';
import { getIconClass } from '../../utils/IconMapper';


const NavItem = ({ navLink, navItem }) => {
  return (
    <li className="mb-3">
      <NavLink to={navLink} className="text-white text-decoration-none">
        <i className={`${getIconClass(navItem)} me-2`}></i> {navItem}
      </NavLink>
    </li>
  );
};

export default NavItem;
